module.exports = __webpack_public_path__ + "static/media/IMG_0618.34ebc651.JPG";